import { useQuery } from '@tanstack/react-query';
import { influencerRepository } from '../repositories/influencer.repository';
import { mapDbRowToInfluencerDetail } from '../services/influencer.mappers';
import { influencerKeys } from '../services/influencer.keys';
import type { InfluencerDetail } from '../types/influencer.types';

export function useInfluencer(id: string | undefined) {
  return useQuery({
    queryKey: influencerKeys.detail(id),
    queryFn: async (): Promise<InfluencerDetail> => {
      if (!id) throw new Error('Influencer ID is required');
      const row = await influencerRepository.getById(id);
      return mapDbRowToInfluencerDetail(row);
    },
    enabled: !!id,
  });
}
